<div class="PageContent">

  <!-- Header Section -->
  <div class="page-header">
    <h1>{{'TransitItems' | translate}}</h1>
  </div>

  <!-- Search and Filter Section -->
  <div class="search-filter-section">
    <!-- Google-style Search Container -->
    <div class="MainOrdersSearchContainer">
      <input
        type="text"
        class="MainOrdersSearch"
        placeholder="{{'SearchAndFilterByPartner' | translate}}..."
        [(ngModel)]="globalPartnerSearchTerm"
        (ngModelChange)="onGlobalPartnerSearch($event)"
        autocomplete="off">
      <i class="material-icons" *ngIf="!FilteredPartner && !(globalPartnerSearchTerm?.length > 0)">search</i>
      <i class="material-icons" *ngIf="FilteredPartner || (globalPartnerSearchTerm?.length > 0)" (click)="ClearGlobalFilter()">close</i>

      <!-- Global Search Results Dropdown -->
      <div class="global-search-results" *ngIf="globalPartnerSearchResults?.length > 0 && !FilteredPartner">
        <div
          class="global-search-result-item"
          *ngFor="let partner of globalPartnerSearchResults"
          (click)="ApplyPartnerFilter(partner)">
          <mat-icon class="result-icon">business</mat-icon>
          <div class="result-content">
            <div class="result-name">{{partner.Name}}</div>
            <div class="result-details">
              <span *ngIf="partner.VAT">VAT: {{partner.VAT}}</span>
              <span *ngIf="partner.BillingAddress?.Country?.Name"> • {{partner.BillingAddress.Country.Name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Active Filter Chip -->
    <div class="active-filter" *ngIf="FilteredPartner">
      <mat-icon>filter_alt</mat-icon>
      <span class="filter-label">{{'FilteredBy' | translate}}:</span>
      <span class="filter-value">{{FilteredPartner.Name}}</span>
      <button mat-icon-button (click)="ClearGlobalFilter()" class="chip-close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Transit Items Table -->
  <div class="table-wrapper">
    <div *ngIf="!this.TransitItems || this.TransitItems.length === 0" class="empty-state">
      <i class="material-icons">inventory_2</i>
      <p>{{'NoTransitItemsYet' | translate}}</p>
    </div>

    <div *ngIf="this.TransitItems && this.TransitItems.length > 0" class="modern-table-container">
      <table class="modern-table">
        <thead>
          <tr>
            <th style="width: 50px;">#</th>
            <th style="width: 140px;">{{'Brand' | translate}}</th>
            <th>{{'Product' | translate}}</th>
            <th style="width: 80px; text-align: center;">{{'Quantity' | translate}}</th>
            <th style="width: 120px;">{{'YourPO' | translate}}</th>
            <th style="width: 140px;">{{'OurConfirmation' | translate}}</th>
            <th style="width: 130px; text-align: center;">{{'EstimatedArrival' | translate}}</th>
            <th style="width: 280px;">{{'AssociatedPartner' | translate}}</th>
            <th style="width: 60px; text-align: center;">{{'Actions' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of this.TransitItems; let i=index;">
            <td class="text-center">{{i + 1}}</td>

            <!-- Brand -->
            <td><strong>{{item.Brand?.Name || '---'}}</strong></td>

            <!-- Product Info -->
            <td>
              <div class="product-info">
                <div class="product-name">{{item.ProductName || '---'}}</div>
                <div class="product-details">
                  <span *ngIf="item.ProductPartNumber?.length > 0" class="detail-item">
                    <span class="detail-label">PN:</span> {{item.ProductPartNumber}}
                  </span>
                </div>
              </div>
            </td>

            <!-- Quantity -->
            <td class="text-center"><strong>{{item.Quantity || 0}}</strong></td>

            <!-- Your PO -->
            <td><span class="badge badge-orange">{{item.DebatorPO || '---'}}</span></td>

            <!-- Our Confirmation -->
            <td><span class="badge badge-success">{{item.OrderRefferenceNumber || '---'}}</span></td>

            <!-- Estimated Arrival -->
            <td class="text-center">
              <span *ngIf="item.EstiMatedArrivalDate" class="badge badge-purple">{{item.EstiMatedArrivalDateUI}}</span>
              <span *ngIf="!item.EstiMatedArrivalDate" style="color: #999;">---</span>
            </td>

            <!-- Partner Dropdown Search -->
            <td>
              <div class="partner-search-container">
                <mat-form-field class="partner-select" appearance="outline">
                  <mat-label>{{'AssociatedPartner' | translate}}</mat-label>
                  <input
                    matInput
                    type="text"
                    [value]="item.Partner?.Name || partnerSearchInputs[i] || ''"
                    (input)="onPartnerSearchChange(i, $any($event.target).value)"
                    [readonly]="!!item.Partner?.Name"
                    placeholder="{{'SearchPartner' | translate}}..."
                    autocomplete="off">

                  <!-- Show X button when partner exists -->
                  <button
                    mat-icon-button
                    matSuffix
                    *ngIf="item.Partner?.Name"
                    (click)="clearPartnerSelection(i, item); $event.stopPropagation();"
                    type="button"
                    class="clear-partner-btn">
                    <mat-icon>close</mat-icon>
                  </button>

                  <!-- Show magnifying glass when no partner -->
                  <mat-icon matSuffix *ngIf="!item.Partner?.Name && !loadingPartners[i]" class="search-icon">search</mat-icon>
                  <mat-spinner matSuffix *ngIf="loadingPartners[i]" diameter="20"></mat-spinner>
                </mat-form-field>

                <!-- Search Results Dropdown -->
                <div class="partner-results" *ngIf="partnerSearchResults[i]?.length > 0 && !item.Partner?.Name">
                  <div
                    class="partner-result-item"
                    *ngFor="let partner of partnerSearchResults[i]"
                    (click)="selectPartner(i, partner)">
                    <div class="partner-name">{{partner.Name}}</div>
                    <div class="partner-details">
                      <span *ngIf="partner.VAT">VAT: {{partner.VAT}}</span>
                      <span *ngIf="partner.BillingAddress?.Country?.Name"> | {{partner.BillingAddress.Country.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>

            <!-- Delete Button -->
            <td class="text-center">
              <button
                mat-icon-button
                class="delete-btn"
                (click)="OpenDeleteConfirmation(item, i)"
                [disabled]="deletingItems[i]"
                matTooltip="{{'DeleteTransitItem' | translate}}"
                matTooltipClass="neutral-tool-tip">
                <mat-spinner *ngIf="deletingItems[i]" [diameter]="20" class="delete-spinner"></mat-spinner>
                <mat-icon *ngIf="!deletingItems[i]">delete</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="pagination-container" *ngIf="this.TransitItems && this.TransitItems.length > 0">
        <div class="pagination-info">
          <span class="info-text">
            {{'Showing' | translate}} {{((CurrentPage - 1) * PageSize) + 1}} - {{Math.min(CurrentPage * PageSize, TotalCount)}} {{'Of' | translate}} {{TotalCount}} {{'Items' | translate}}
          </span>
        </div>
        <div class="pagination-controls">
          <button
            mat-icon-button
            [disabled]="CurrentPage === 1"
            (click)="GoToPage(1)"
            class="pagination-btn">
            <mat-icon>first_page</mat-icon>
          </button>
          <button
            mat-icon-button
            [disabled]="CurrentPage === 1"
            (click)="GoToPage(CurrentPage - 1)"
            class="pagination-btn">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <div class="page-numbers">
            <button
              *ngFor="let page of GetPageNumbers()"
              mat-button
              [class.active]="page === CurrentPage"
              (click)="GoToPage(page)"
              class="page-number-btn">
              {{page}}
            </button>
          </div>

          <button
            mat-icon-button
            [disabled]="CurrentPage === TotalPages"
            (click)="GoToPage(CurrentPage + 1)"
            class="pagination-btn">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button
            mat-icon-button
            [disabled]="CurrentPage === TotalPages"
            (click)="GoToPage(TotalPages)"
            class="pagination-btn">
            <mat-icon>last_page</mat-icon>
          </button>
        </div>
        <div class="page-size-selector">
          <mat-form-field appearance="outline" class="page-size-field">
            <mat-select [(value)]="PageSize" (selectionChange)="OnPageSizeChange()">
              <mat-option [value]="10">10 / {{'Page' | translate}}</mat-option>
              <mat-option [value]="25">25 / {{'Page' | translate}}</mat-option>
              <mat-option [value]="50">50 / {{'Page' | translate}}</mat-option>
              <mat-option [value]="100">100 / {{'Page' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Delete Confirmation Dialog -->
<div class="overlay" *ngIf="ShowDeleteConfirmation" (click)="CloseDeleteConfirmation()"></div>

<div class="delete-confirmation-dialog animated fadeInDown" *ngIf="ShowDeleteConfirmation">
  <div class="dialog-header">
    <mat-icon class="warning-icon">warning</mat-icon>
    <h2>{{'ConfirmDeletion' | translate}}</h2>
    <button mat-icon-button class="close-btn" (click)="CloseDeleteConfirmation()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <p>{{'DeleteTransitItemConfirmation' | translate}}</p>
    <div class="item-details" *ngIf="ItemToDelete">
      <div class="detail-row">
        <span class="label">{{'Product' | translate}}:</span>
        <span class="value">{{ItemToDelete.ProductName}}</span>
      </div>
      <div class="detail-row" *ngIf="ItemToDelete.ProductPartNumber">
        <span class="label">{{'PartNumber' | translate}}:</span>
        <span class="value">{{ItemToDelete.ProductPartNumber}}</span>
      </div>
      <div class="detail-row">
        <span class="label">{{'Quantity' | translate}}:</span>
        <span class="value">{{ItemToDelete.Quantity}}</span>
      </div>
      <div class="detail-row" *ngIf="ItemToDelete.OrderRefferenceNumber">
        <span class="label">{{'OurConfirmation' | translate}}:</span>
        <span class="value">{{ItemToDelete.OrderRefferenceNumber}}</span>
      </div>
    </div>
    <p class="warning-text">{{'ThisActionCannotBeUndone' | translate}}</p>
  </div>

  <div class="dialog-actions">
    <button mat-raised-button (click)="CloseDeleteConfirmation()" class="cancel-btn">
      {{'Cancel' | translate}}
    </button>
    <button mat-raised-button color="warn" (click)="ConfirmDelete()" class="delete-btn-confirm">
      <mat-icon>delete</mat-icon>
      {{'Delete' | translate}}
    </button>
  </div>
</div>